import type { ButtonProps } from './button.types';
import { cn } from '@/utils/helper';
import v1 from './button-v1.module.css';
import v2 from './button-v2.module.css';

export default function Button(props: ButtonProps) {
  return (
    <button type='button' className={cn(v1.Button, v2.Button)} onClick={() => props.onClick()}>
      {props.content}
    </button>
  );
}
